module.exports = __webpack_public_path__ + "images/facility-logo.89320fbe1731023eb6d603f41d298fc3.png";